import { LOGOUT_USER, SET_LOGGED_IN_USER } from '../../actions/auth';
import { checkIfLimitFlowPresent } from '../../helpers';
import { currentFlowTypeEnum } from '../../pages/common/components/constants';

export default function user(state = {}, action = {}) {
  const { type = '', user: userData = {} } = action;

  switch (type) {
    case SET_LOGGED_IN_USER: {
      userData.workspaces = userData.workspaces.reduce((acc, workspace) => {
        acc[workspace.workspace_id] = workspace;
        return acc;
      }, {});

      const [selectedWorkspace] = Object.values(userData.workspaces) ?? {};
      userData.selectedWorkspace = selectedWorkspace;
      // TODO: change this is case of a switch
      userData.currentFlow = checkIfLimitFlowPresent(
        selectedWorkspace?.applicable_flows ?? [],
      )
        ? currentFlowTypeEnum.FLOW_TYPE_LIMIT
        : currentFlowTypeEnum.FLOW_TYPE_PPI;

      const loggedInUserData = userData || {};

      return {
        ...state,
        ...loggedInUserData,
      };
    }

    case LOGOUT_USER:
      return {};

    default:
      return state;
  }
}
